import React, {Component} from 'react';
import ReactTable from 'react-table-6';
import 'react-table-6/react-table.css';
import {Button, Col, Container, Row} from "react-bootstrap";
import firebase from 'firebase/app';
import Util from "../../../util/Util";
import Loading from "../shared/loading/Loading";
import "./portletTable.scss";
import {NavLink} from "react-router-dom";
import HeaderDescription from "../dashboard/HeaderDescription";
import ModalDelete from "../modal/ModalDelete";
import moment from 'moment';

const ActionCell = (row: any)=> {
    return (
        <div className={"cell-action-wrapper"}>
            <NavLink to={`../starters/edit/${row.original.id}`}>
                <Button>
                    Edit
                </Button>
            </NavLink>
            <Button
                variant={"danger"}
                onClick={()=> row.original.component.setState({
                    showModalDelete: true,
                    record: {
                        id: row.original.id,
                        name: row.original.name
                    }
                })}>
                Delete
            </Button>
        </div>
    );
};

const columns = [
    {
        Header: 'Name',
        accessor: 'name' // String-based value accessors!
    },
    {
        Header: 'Age',
        accessor: 'age' // String-based value accessors!
    },
    {
        Header: 'Job Position',
        accessor: 'job' // String-based value accessors!
    },
    {
        Header: 'Rating',
        accessor: 'rating' // String-based value accessors!
    },
    {
        Header: 'Review',
        accessor: 'review' // String-based value accessors!
    },
    {
        Header: 'Actions',
        accessor: 'actions', // String-based value accessors!
        Cell: ActionCell,
        width: 150
    }
];

type Props = {
    companyId: string,
    section: string,
    dashboard: string
};

type State = {
    searchField: string,
    data: Array<any>,
    filteredCompanies: Array<any>,
    loading: boolean,
    selectAll: boolean,
    selection: Array<any>,
    loadingData: boolean,
    showModalDelete: boolean,
    feedback: Array<any>;
    record: {
        name: string,
        id: string,
    };
};


class StarterList extends Component<Props, State> {
    // @ts-ignore
    checkboxTable: ReactTable;

    state: State = {
        searchField: "",
        data: [],
        filteredCompanies: [],
        loading: false,
        selectAll: false,
        selection: [],
        loadingData: true,
        showModalDelete: false,
        feedback: [],
        record: {
            name: "",
            id: ""
        }
    };

    componentDidMount(): void {
        this.loadData();
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        if(prevProps.companyId !== this.props.companyId){
            this.loadData();
        }
    }

    loadData = () => {
        this.setState({loadingData: true});
        firebase.database().ref(`companies/${this.props.companyId}/reviewers`).on('value', (snapshot: any) => {
            if(snapshot && snapshot.val() ){
                this.setState({data: this.mapStarters(snapshot.val()), loadingData: false});
            }else{
                this.setState({data: [], loadingData: false});
            }
        });
    };

    mapStarters = (data: any): Array<any> => {
        return Object.keys(data).map((key: any)=> {
            return {
                id: key,
                name: Util.decodeCharacters(data[key].name),
                age: data[key].age,
                job: Util.decodeCharacters(data[key].job),
                rating: data[key].rating,
                review: Util.decodeCharacters(data[key].review.join()),
                component: this
            }
        });
    };

    deleteRecord = (id: string, name: string) => {
        this.setState({showModalDelete: false});
        firebase.database().ref(`companies/${this.props.companyId}/reviewers`).update({[id]: null}).then(()=>{
            this.pushFeedback({
                type: "success",
                title: "Starter deleted",
                text: `Starter ${name} was deleted!`,
                id: moment.now(),
            })
        });
    };

    pushFeedback = ( feedbackData : any)=>{
        let feedBack = this.state.feedback;
        this.setState({feedback: [feedbackData , ...feedBack]})
    };

    render() {
        const {
            props: {companyId, dashboard, section},
            state: {data, loadingData, feedback, showModalDelete, record}
        }= this;

        return (
            <Container className={"portlet-wrapper"}>
                <HeaderDescription
                    companyId={companyId}
                    dashboard={dashboard}
                    section={section}
                    icon={"fas fa-user-tie"}
                    feedback={feedback}
                    name={"Starters"} />
                <Row>
                    <Col>
                        <div className="toolbar-dashboard">
                            <NavLink to={`/cms/${companyId}/${section}/add`} className={"btn btn-success"}>
                                <i className="fas fa-plus"/> Add starter
                            </NavLink>
                            <NavLink target={"_black"} to={`/company/${companyId}/details#starters`} className={"btn btn-light float-right"}>
                                <i className="fas fa-globe-europe"/> See website
                            </NavLink>
                        </div>
                    </Col>
                </Row>
                <Row noGutters>
                    <Col>
                        {loadingData?
                            <Loading/>:
                            <ReactTable
                                data={data}
                                columns={columns}
                            />
                        }
                    </Col>
                </Row>
                <ModalDelete
                    showModal={showModalDelete}
                    onHide={()=> this.setState({showModalDelete: false})}
                    onDelete={()=> this.deleteRecord(record.id, record.name )}
                    title={"Delete Starter?"}
                    message={`You are about to delete starter: ${record.name}`}/>
            </Container>
        );
    }
}

export default StarterList;
